module.exports = __webpack_public_path__ + "static/img/fg4.a739592.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/xinqingBrand/assets/fg4.png
// module id = mOwq
// module chunks = 0